import React, { useState, useEffect } from 'react';

const API = 'https://api.whatmarket.pixcovery.mx';

const COLORES = [
  { color:'#7A8F89', bg:'#F0F4F0' },
  { color:'#042C53', bg:'#E6F1FB' },
  { color:'#26215C', bg:'#EEEDFE' },
  { color:'#128C7E', bg:'#E1F5EE' },
  { color:'#E65100', bg:'#FFF3E0' },
];

function getColor(index) {
  return COLORES[index % COLORES.length];
}

const S = {
  topbar:     { display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:20 },
  h1:         { fontSize:20, fontWeight:700, color:'#0D1F1A' },
  btnNew:     { padding:'8px 16px', borderRadius:10, border:'none', background:'#075E54', color:'white', fontSize:13, fontWeight:700, cursor:'pointer', fontFamily:'inherit' },
  grid:       { display:'grid', gridTemplateColumns:'repeat(3,1fr)', gap:16, marginBottom:24 },
  planCard:   { background:'white', borderRadius:16, border:'1px solid #E4EDE8', overflow:'hidden' },
  planTop:    { padding:'16px', borderBottom:'1px solid #E4EDE8' },
  planNombre: { fontSize:16, fontWeight:800, color:'#0D1F1A', marginBottom:4 },
  planDesc:   { fontSize:12, color:'#7A8F89', marginBottom:12 },
  planPrecio: { fontSize:28, fontWeight:800, color:'#0D1F1A' },
  planMes:    { fontSize:12, color:'#7A8F89', fontWeight:400 },
  planBody:   { padding:'14px 16px' },
  planRow:    { display:'flex', justifyContent:'space-between', alignItems:'center', padding:'6px 0', borderBottom:'1px solid #E4EDE8', fontSize:12 },
  planRowLast:{ borderBottom:'none' },
  planLbl:    { color:'#7A8F89' },
  planVal:    { fontWeight:700, color:'#0D1F1A' },
  feat:       { fontSize:12, color:'#7A8F89', padding:'4px 0', display:'flex', alignItems:'center', gap:6 },
  planActions:{ padding:'12px 16px', borderTop:'1px solid #E4EDE8', display:'flex', gap:8 },
  btnEdit:    { flex:1, padding:'8px', borderRadius:10, border:'1px solid #E4EDE8', background:'#F0F4F0', color:'#0D1F1A', fontSize:12, fontWeight:600, cursor:'pointer', fontFamily:'inherit' },
  btnToggle:  { flex:1, padding:'8px', borderRadius:10, border:'none', fontSize:12, fontWeight:600, cursor:'pointer', fontFamily:'inherit' },
  badge:      { display:'inline-block', padding:'2px 10px', borderRadius:20, fontSize:11, fontWeight:600 },
  overlay:    { position:'fixed', inset:0, background:'rgba(0,0,0,0.5)', zIndex:200, display:'flex', alignItems:'center', justifyContent:'center' },
  modal:      { background:'white', borderRadius:16, padding:24, width:420 },
  modalTitle: { fontSize:16, fontWeight:800, color:'#0D1F1A', marginBottom:20 },
  field:      { marginBottom:14 },
  label:      { display:'block', fontSize:11, fontWeight:700, color:'#7A8F89', textTransform:'uppercase', letterSpacing:0.5, marginBottom:6 },
  input:      { width:'100%', background:'#F0F4F0', border:'1.5px solid #E4EDE8', borderRadius:10, padding:'10px 12px', fontSize:14, color:'#0D1F1A', outline:'none', fontFamily:'inherit', boxSizing:'border-box' },
  modalBtns:  { display:'flex', gap:8, marginTop:20 },
  btnCancel:  { flex:1, padding:10, borderRadius:10, border:'1px solid #E4EDE8', background:'#F0F4F0', color:'#7A8F89', fontSize:13, cursor:'pointer', fontFamily:'inherit' },
  btnSave:    { flex:1, padding:10, borderRadius:10, border:'none', background:'#075E54', color:'white', fontSize:13, fontWeight:700, cursor:'pointer', fontFamily:'inherit' },
  cargando:   { textAlign:'center', padding:40, color:'#7A8F89', fontSize:13 },
  error:      { background:'#FCEBEB', border:'1px solid #F09595', borderRadius:10, padding:'10px 14px', fontSize:12, color:'#A32D2D', marginBottom:16 },
};

export default function Planes() {
  const [planes,     setPlanes]     = useState([]);
  const [cargando,   setCargando]   = useState(true);
  const [errorMsg,   setErrorMsg]   = useState('');
  const [editando,   setEditando]   = useState(null);
  const [form,       setForm]       = useState({});
  const [hayCambios, setHayCambios] = useState(false);
  const [guardando,  setGuardando]  = useState(false);

  useEffect(() => { cargarPlanes(); }, []);

  async function cargarPlanes() {
    try {
      setCargando(true);
      const res = await fetch(`${API}/admin/planes`);
      const data = await res.json();
      setPlanes(data.map((p, i) => ({ ...p, ...getColor(i), caracteristicas: Array.isArray(p.caracteristicas) ? p.caracteristicas : [] })));
    } catch (err) {
      setErrorMsg('Error cargando planes: ' + err.message);
    } finally {
      setCargando(false);
    }
  }

  function actualizarForm(campo, valor) {
    setForm(prev => ({ ...prev, [campo]: valor }));
    setHayCambios(true);
  }

  function cerrarModal() {
    if (hayCambios && !window.confirm('Tienes cambios sin guardar. ¿Seguro que quieres cerrar?')) return;
    setHayCambios(false);
    setEditando(null);
  }

  function abrirEditar(plan) {
    setHayCambios(false);
    setForm({
      nombre:          plan.nombre,
      precio:          plan.precio,
      comision:        plan.comision,
      descripcion:     plan.descripcion,
      caracteristicas: (plan.caracteristicas || []).join('\n'),
    });
    setEditando(plan.id);
  }

  async function guardar() {
    if (!form.nombre.trim())      { alert('Escribe el nombre del plan'); return; }
    if (form.precio === '')       { alert('Escribe el precio del plan'); return; }
    if (form.comision === '')     { alert('Escribe el porcentaje de comisión'); return; }
    if (!form.descripcion.trim()) { alert('Escribe una descripción'); return; }

    const payload = {
      nombre:          form.nombre,
      precio:          parseFloat(String(form.precio).replace(/,/g,'')) || 0,
      comision:        parseFloat(String(form.comision).replace(/,/g,'')) || 0,
      descripcion:     form.descripcion,
      caracteristicas: form.caracteristicas.split('\n').filter(Boolean),
      activo:          true,
    };

    setGuardando(true);
    try {
      if (editando === 'nuevo') {
        const res = await fetch(`${API}/admin/planes`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload),
        });
        const nuevo = await res.json();
        const color = getColor(planes.length);
        setPlanes(prev => [...prev, { ...nuevo, ...color, caracteristicas: Array.isArray(nuevo.caracteristicas) ? nuevo.caracteristicas : [] }]);
      } else {
        await fetch(`${API}/admin/planes/${editando}`, {
          method: 'PUT',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload),
        });
        setPlanes(prev => prev.map(p => p.id === editando ? { ...p, ...payload } : p));
      }
      setHayCambios(false);
      setEditando(null);
    } catch (err) {
      alert('Error guardando plan: ' + err.message);
    } finally {
      setGuardando(false);
    }
  }

  async function toggleActivo(plan) {
    const nuevoActivo = !plan.activo;
    try {
      await fetch(`${API}/admin/planes/${plan.id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ...plan, activo: nuevoActivo }),
      });
      setPlanes(prev => prev.map(p => p.id === plan.id ? { ...p, activo: nuevoActivo } : p));
    } catch (err) {
      alert('Error actualizando plan: ' + err.message);
    }
  }

  if (cargando) return <div style={S.cargando}>Cargando planes...</div>;

  return (
    <div>
      <div style={S.topbar}>
        <h1 style={S.h1}>Planes ({planes.length})</h1>
        <button style={S.btnNew} onClick={() => {
          setForm({ nombre:'', precio:'', comision:'', descripcion:'', caracteristicas:'' });
          setHayCambios(false);
          setEditando('nuevo');
        }}>＋ Nuevo plan</button>
      </div>

      {errorMsg && <div style={S.error}>{errorMsg}</div>}

      <div style={S.grid}>
        {planes.map(plan => (
          <div key={plan.id} style={{ ...S.planCard, opacity: plan.activo ? 1 : 0.6 }}>
            <div style={{ ...S.planTop, borderTop: `4px solid ${plan.color}` }}>
              <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start', marginBottom:8 }}>
                <div>
                  <div style={S.planNombre}>{plan.nombre}</div>
                  <div style={S.planDesc}>{plan.descripcion}</div>
                </div>
                <span style={{ ...S.badge, background: plan.activo ? '#E1F5EE' : '#F0F4F0', color: plan.activo ? '#085041' : '#7A8F89' }}>
                  {plan.activo ? 'Activo' : 'Inactivo'}
                </span>
              </div>
              <div style={S.planPrecio}>
                {Number(plan.precio) === 0 ? 'Gratis' : `$${Number(plan.precio).toLocaleString('es-MX', { minimumFractionDigits:2 })}`}
                {Number(plan.precio) > 0 && <span style={S.planMes}>/mes</span>}
              </div>
            </div>
            <div style={S.planBody}>
              <div style={S.planRow}>
                <span style={S.planLbl}>Comisión por venta</span>
                <span style={{ ...S.planVal, color: Number(plan.comision)===0 ? '#7A8F89':'#075E54' }}>{plan.comision}%</span>
              </div>
              <div style={{ ...S.planRow, ...S.planRowLast }}>
                <span style={S.planLbl}>Precio mensual</span>
                <span>{Number(plan.precio)===0 ? 'Sin costo' : `$${Number(plan.precio).toLocaleString('es-MX', { minimumFractionDigits:2 })} MXN`}</span>
              </div>
              <div style={{ marginTop:10 }}>
                {(plan.caracteristicas||[]).map((c, i) => (
                  <div key={i} style={S.feat}>✓ {c}</div>
                ))}
              </div>
            </div>
            <div style={S.planActions}>
              <button style={S.btnEdit} onClick={() => abrirEditar(plan)}>✏️ Editar</button>
              <button
                style={{ ...S.btnToggle, background: plan.activo ? '#FCEBEB':'#E1F5EE', color: plan.activo ? '#A32D2D':'#085041' }}
                onClick={() => toggleActivo(plan)}>
                {plan.activo ? '⏸ Desactivar' : '▶ Activar'}
              </button>
            </div>
          </div>
        ))}
      </div>

      {editando && (
        <div style={S.overlay} onClick={e => e.target===e.currentTarget && cerrarModal()}>
          <div style={S.modal}>
            <div style={S.modalTitle}>{editando==='nuevo' ? '＋ Nuevo plan' : '✏️ Editar plan'}</div>
            <div style={S.field}>
              <label style={S.label}>Nombre del plan</label>
              <input style={S.input} value={form.nombre} onChange={e => actualizarForm('nombre', e.target.value)} />
            </div>
            <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:12 }}>
              <div style={S.field}>
                <label style={S.label}>Precio mensual ($MXN)</label>
                <input style={S.input} type="text" inputMode="decimal"
                  value={form.precio}
                  onFocus={e => e.target.select()}
                  onChange={e => actualizarForm('precio', e.target.value.replace(/[^0-9.]/g,''))}
                  onBlur={e => {
                    const num = parseFloat(e.target.value) || 0;
                    actualizarForm('precio', num.toLocaleString('es-MX', { minimumFractionDigits:2 }));
                  }}
                />
              </div>
              <div style={S.field}>
                <label style={S.label}>Comisión (%)</label>
                <input style={S.input} type="text" inputMode="decimal"
                  value={form.comision}
                  onFocus={e => e.target.select()}
                  onChange={e => actualizarForm('comision', e.target.value.replace(/[^0-9.]/g,''))}
                  onBlur={e => actualizarForm('comision', parseFloat(e.target.value)||0)}
                />
              </div>
            </div>
            <div style={S.field}>
              <label style={S.label}>Descripción</label>
              <input style={S.input} value={form.descripcion} onChange={e => actualizarForm('descripcion', e.target.value)} />
            </div>
            <div style={S.field}>
              <label style={S.label}>Características (una por línea)</label>
              <textarea style={{ ...S.input, height:90, resize:'none' }} value={form.caracteristicas} onChange={e => actualizarForm('caracteristicas', e.target.value)} />
            </div>
            <div style={S.modalBtns}>
              <button style={S.btnCancel} onClick={cerrarModal}>Cancelar</button>
              <button style={{ ...S.btnSave, opacity: guardando ? 0.7 : 1 }} onClick={guardar} disabled={guardando}>
                {guardando ? 'Guardando...' : '✓ Guardar cambios'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}